import { MCountry } from "./country.model";
import { MOrganizationType } from "./organization-type.model";
import { MToolbox } from "./toolbox.model";
import { Organization } from "../interfaces/Organization";
import { MLanguage } from "./language.model";

export class MOrganization {
  email: string;
  address: string;
  id: number;
  identification: string;
  code: string;
  logo: string;
  maxUsersH: string;
  maxUsersS: string;
  name: string;
  country: MCountry;
  organizationType: MOrganizationType;
  toolboxes: MToolbox[];
  public language: MLanguage;
  constructor(organization: Organization) {
    this.email = organization.correo;
    this.address = organization.direccion;
    this.id = organization.id;
    this.identification = organization.identificacion;
    this.code = organization.codigo;
    this.logo = organization.logo;
    this.maxUsersH = organization.maximo_usuarios_h;
    this.maxUsersS = organization.maximo_usuarios_s;
    this.name = organization.nombre;
    this.country = new MCountry(organization.pais);
    this.organizationType = new MOrganizationType(
      organization.tipo_organizacion
    );
    this.toolboxes = [];
    this.language = new MLanguage(organization.idioma);
    for (let i = 0; i < organization.toolboxes.length; i++) {
      this.toolboxes.push(new MToolbox(organization.toolboxes[i]));
    }
  }
}
